const FEATURE_FLAGS = {
  bookings: String(import.meta.env.REACT_APP_FEATURE_BOOKINGS).toLowerCase() === 'true',
}

export const isFeatureEnabled = name => !!FEATURE_FLAGS[name]
